// Helpers for the /games/{gameId}/chats subcollection.
// Chat lives outside the game doc so spectators (unauthenticated) can't read it.

import { addDoc, collection, doc } from 'firebase/firestore';
import { db } from '../../../firebaseConfig';

export const chatColRef = (gameId) => collection(db, 'games', gameId, 'chats');

// One-off chat write
export const pushChat = (gameId, message) => addDoc(chatColRef(gameId), message);

// Queue a chat write onto a writeBatch (atomic with parent updates)
export const batchPushChat = (batch, gameId, message) => {
  const ref = doc(chatColRef(gameId));
  batch.set(ref, message);
  return ref;
};
